import { minimalHeaderFormConfigOptions } from 'platform/forms-system/src/js/patterns/minimal-header';
import FormFooter from 'platform/forms/components/FormFooter';
import { VA_FORM_IDS } from 'platform/forms/constants';
import { externalServices } from 'platform/monitoring/DowntimeNotification';
import environment from 'platform/utilities/environment';
import DowntimeWarning from '../components/FormAlerts/DowntimeWarning';
import SubmissionErrorAlert from '../components/FormAlerts/SubmissionErrorAlert';
import GetFormHelp from '../components/GetFormHelp';
import PreSubmitNotice from '../components/PreSubmitNotice';
import ConfirmationPage from '../containers/ConfirmationPage';
import IntroductionPage from '../containers/IntroductionPage';
import content from '../locales/en/content.json';
import manifest from '../manifest.json';
import { FULL_SCHEMA } from '../utils/imports';
import { chapters } from './chapters';
import { additionalRoutes } from './chapters/additionalRoutes';
import migrations from './migrations';
import { prefillTransformer } from './prefillTransformer';
import { submitTransformer } from './submitTransformer';

const breadcrumbList = [
  { href: '/', label: '' },
  {
    href: '/forms',
    label: content['form-breadcrumb--forms'],
  },
  {
    href: '/forms/10-10ez',
    label: content['form-breadcrumb--1010ez'],
  },
  { href: '#content', label: content['form-title'] },
];

/** @type {FormConfig}  */
const formConfig = {
  // identity & routing
  formId: VA_FORM_IDS.FORM_10_10EZ,
  rootUrl: manifest.rootUrl,
  urlPrefix: '/',

  // tracking & monitoring
  trackingPrefix: 'hca-',
  downtime: {
    dependencies: [externalServices['1010ez']],
    message: DowntimeWarning,
  },

  // state management
  migrations,
  prefillTransformer,
  prefillEnabled: true,
  version: migrations.length,
  savedFormMessages: {
    notFound: content['form-message--not-found'],
    noAuth: content['form-message--no-auth'],
  },

  // submission configuration
  submitUrl: `${environment.API_URL}/v0/health_care_applications`,
  preSubmitInfo: {
    required: true,
    field: 'privacyAgreementAccepted',
    CustomComponent: PreSubmitNotice,
  },
  submissionError: SubmissionErrorAlert,
  transformForSubmit: submitTransformer,

  // form options
  defaultDefinitions: FULL_SCHEMA.definitions,
  requireIdentityVerification: true,
  formOptions: {
    useWebComponentForNavigation: true,
    filterInactiveNestedPageData: true,
  },

  // development settings
  dev: { disableWindowUnloadInCI: true },

  // header & display text
  ...minimalHeaderFormConfigOptions({
    homeVeteransAffairs: true,
    wrapping: true,
    breadcrumbList,
  }),
  title: content['form-title'],
  subTitle: content['form-subtitle'],

  // page structure
  introduction: IntroductionPage,
  confirmation: ConfirmationPage,
  footerContent: FormFooter,
  getHelp: GetFormHelp,
  additionalRoutes,
  chapters,
};

export default formConfig;
